import { atomWithReset } from "jotai/utils";

interface FirstAccessValues {
  document: string;
  email?: string | null;
  methodId?: string | null;
}

export const firstAccessAtom = atomWithReset<FirstAccessValues>({
  document: "",
  email: null,
  methodId: null,
});
